import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { API } from "../../lib/api";

// Ventana de vista previa de lo que se construye en el taller. La página viaja por un puente seguro del panel (nunca se abre un puerto del taller a internet) y se muestra aislada
// (sandbox sin acceso a tu sesión). El enlace es una clave larga y aleatoria: sirve para abrirla en una pestaña nueva o compartirla, y deja de funcionar cuando la vista previa se apaga.
export function previewUrl(token) {
  return `${API}/p/${token}/`;
}

export function PreviewWindow({ open, onOpenChange, token, title }) {
  const [copied, setCopied] = useState(false);
  const url = token ? previewUrl(token) : "";

  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  const copy = async () => {
    try {
      const absolute = url.startsWith("http") ? url : `${window.location.origin}${url}`;
      await navigator.clipboard.writeText(absolute);
      setCopied(true);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="preview-window" className="max-w-5xl w-[95vw]">
        <DialogHeader>
          <DialogTitle>{title ? `Vista previa: ${title}` : "Vista previa"}</DialogTitle>
          <DialogDescription>
            Así se ve en el taller. Navégala y pruébala; si quieres cambios, pídeselos al Orquestador en el chat. Se apaga sola tras 30 minutos sin uso (se reabre con «Previsualizar»).
          </DialogDescription>
        </DialogHeader>
        {url && (
          <iframe
            data-testid="preview-frame"
            title={title || "Vista previa"}
            src={url}
            sandbox="allow-scripts allow-forms allow-popups allow-modals allow-downloads"
            className="w-full h-[65vh] rounded-lg border border-border bg-white"
          />
        )}
        <div className="flex flex-wrap gap-2 justify-end">
          <Button data-testid="preview-copy" variant="outline" size="sm" onClick={copy}>
            {copied ? "Enlace copiado ✅" : "Copiar enlace"}
          </Button>
          <Button data-testid="preview-newtab" size="sm" onClick={() => window.open(url, "_blank", "noopener")}>
            Abrir en pestaña nueva
          </Button>
          <Button data-testid="preview-close" variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Cerrar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// Escucha el aviso «abrir vista previa» (lo manda el botón del mensaje o el botón «Previsualizar») y muestra la ventana.
export function PreviewHost() {
  const [state, setState] = useState({ open: false, token: "", title: "" });
  useEffect(() => {
    const handler = (event) => setState({ open: true, token: event.detail?.token || "", title: event.detail?.title || "" });
    window.addEventListener("open-preview", handler);
    return () => window.removeEventListener("open-preview", handler);
  }, []);
  return <PreviewWindow open={state.open} onOpenChange={(open) => setState((s) => ({ ...s, open }))} token={state.token} title={state.title} />;
}

export function openPreview(token, title) {
  window.dispatchEvent(new CustomEvent("open-preview", { detail: { token, title } }));
}
